import routerConstants from "./routerConstants";
import {
    FileTextOutlined,
    HistoryOutlined,
    UserOutlined,
    BellOutlined,
    TeamOutlined,
    SolutionOutlined,
    BankOutlined,
    DollarOutlined,
    BuildOutlined,
    CalendarOutlined,
    ShareAltOutlined,
    AppstoreOutlined,
    DashboardOutlined,
    HomeOutlined,
    FileDoneOutlined,
    ClockCircleOutlined,
    CheckCircleOutlined,
    ToolOutlined,
    ExperimentOutlined,
    NodeIndexOutlined,
    ApartmentOutlined,
    LayoutOutlined,
    RocketOutlined,
    ReadOutlined,
} from '@ant-design/icons';

interface IMenu {
    key: string;
    startPoint: string;
    path: string;
    label: string;
    icon: any;
    children: IMenu[];
}

/** Build sidebar menus. Call `hasMenu` from `useMenuChucNang` inside a component — do not call hooks here. */
export const userMenu = (hasMenu: (urlPath: string) => boolean) => {
    let menuApps: IMenu[] = [];

    const getMenuSystem = () => {
        const availableMenus: IMenu[] = [];
        // user - quản trị người dùng
        if (hasMenu(routerConstants.user.list)) {
            availableMenus.push({ key: 'user', startPoint: routerConstants.user.name, path: routerConstants.user.list, label: 'Người dùng', icon: UserOutlined, children: [] });
        }
        // notification - quản trị thông báo
        if (hasMenu(routerConstants.notification.list)) {
            availableMenus.push({ key: 'notification', startPoint: routerConstants.notification.name, path: routerConstants.notification.list, label: 'Thông báo', icon: BellOutlined, children: [] });
        }
        // social — chuyển ra menu gốc riêng (getMenuSocial)
        // audit
        if (hasMenu(routerConstants.audit.list)) {
            availableMenus.push({ key: 'audit', startPoint: routerConstants.audit.name, path: routerConstants.audit.list, label: 'Lịch sử hoạt động', icon: HistoryOutlined, children: [] });
        }
        return availableMenus;
    }

    const getMenuHR = () => {
        const availableMenus: IMenu[] = [];
        // userProfile
        if (hasMenu(routerConstants.nhanSu.hoSoNhanVien.list)) {
            availableMenus.push({ key: 'userProfile', startPoint: routerConstants.nhanSu.hoSoNhanVien.name, path: routerConstants.nhanSu.hoSoNhanVien.list, label: 'Hồ sơ nhân viên', icon: UserOutlined, children: [] });
        }
        // department
        if (hasMenu(routerConstants.nhanSu.phongBan.list)) {
            availableMenus.push({ key: 'department', startPoint: routerConstants.nhanSu.phongBan.name, path: routerConstants.nhanSu.phongBan.list, label: 'Phòng ban', icon: TeamOutlined, children: [] });
        }
        // jobTitle
        if (hasMenu(routerConstants.nhanSu.chucDanh.list)) {
            availableMenus.push({ key: 'jobTitle', startPoint: routerConstants.nhanSu.chucDanh.name, path: routerConstants.nhanSu.chucDanh.list, label: 'Chức danh', icon: SolutionOutlined, children: [] });
        }
        // insurancePayment
        if (hasMenu(routerConstants.nhanSu.thanhToanBaoHiem.list)) {
            availableMenus.push({ key: 'insurancePayment', startPoint: routerConstants.nhanSu.thanhToanBaoHiem.name, path: routerConstants.nhanSu.thanhToanBaoHiem.list, label: 'Thanh toán BH', icon: BankOutlined, children: [] });
        }
        // insuranceBenefit
        if (hasMenu(routerConstants.nhanSu.quyenLoiBaoHiem.list)) {
            availableMenus.push({ key: 'insuranceBenefit', startPoint: routerConstants.nhanSu.quyenLoiBaoHiem.name, path: routerConstants.nhanSu.quyenLoiBaoHiem.list, label: 'Quyền lợi BH', icon: BankOutlined, children: [] });
        }
        // welfareFund
        if (hasMenu(routerConstants.nhanSu.quyPhucLoi.list)) {
            availableMenus.push({ key: 'welfareFund', startPoint: routerConstants.nhanSu.quyPhucLoi.name, path: routerConstants.nhanSu.quyPhucLoi.list, label: 'Quỹ phúc lợi', icon: BankOutlined, children: [] });
        }
        return availableMenus;
    }

    const getMenuDaoTao = () => {
        const availableMenus: IMenu[] = [];
        const khoaHocList = routerConstants.daoTao.khoaHocDaoTao.list;
        const legacyKhoaHocList = '/nhan-su/khoa-hoc-dao-tao/list';
        if (hasMenu(khoaHocList) || hasMenu(legacyKhoaHocList)) {
            availableMenus.push({
                key: 'trainingCourse',
                startPoint: routerConstants.daoTao.khoaHocDaoTao.name,
                path: khoaHocList,
                label: 'Khóa đào tạo',
                icon: FileTextOutlined,
                children: [],
            });
        }
        return availableMenus;
    }

    const getMenuRecruitment = () => {
        const availableMenus: IMenu[] = [];
        // dashboard
        if (hasMenu(routerConstants.tuyenDung.trangChu.list)) {
            availableMenus.push({ key: 'recruitmentDashboard', startPoint: routerConstants.tuyenDung.trangChu.list, path: routerConstants.tuyenDung.trangChu.list, label: 'Dashboard Tuyển dụng', icon: DashboardOutlined, children: [] });
        }
        // recruitmentRequest
        if (hasMenu(routerConstants.tuyenDung.yeuCauTuyenDung.list)) {
            availableMenus.push({ key: 'recruitmentRequest', startPoint: routerConstants.tuyenDung.yeuCauTuyenDung.name, path: routerConstants.tuyenDung.yeuCauTuyenDung.list, label: 'Yêu cầu tuyển dụng', icon: SolutionOutlined, children: [] });
        }
        // jobPosting
        if (hasMenu(routerConstants.tuyenDung.dangTuyen.listAll)) {
            availableMenus.push({ key: 'jobPosting', startPoint: routerConstants.tuyenDung.dangTuyen.name, path: routerConstants.tuyenDung.dangTuyen.listAll, label: 'Đăng tuyển', icon: FileTextOutlined, children: [] });
        }
        // candidate
        if (hasMenu(routerConstants.tuyenDung.ungVien.listAll)) {
            availableMenus.push({ key: 'candidate', startPoint: routerConstants.tuyenDung.ungVien.name, path: routerConstants.tuyenDung.ungVien.listAll, label: 'Ứng viên', icon: UserOutlined, children: [] });
        }
        // interviewSchedule
        if (hasMenu(routerConstants.tuyenDung.lichPhongVan.listAll)) {
            availableMenus.push({ key: 'interviewSchedule', startPoint: routerConstants.tuyenDung.lichPhongVan.name, path: routerConstants.tuyenDung.lichPhongVan.listAll, label: 'Lịch phỏng vấn', icon: CalendarOutlined, children: [] });
        }
        // jobOffer
        if (hasMenu(routerConstants.tuyenDung.thuMoiLamViec.listAll)) {
            availableMenus.push({ key: 'jobOffer', startPoint: routerConstants.tuyenDung.thuMoiLamViec.name, path: routerConstants.tuyenDung.thuMoiLamViec.listAll, label: 'Job Offer', icon: FileDoneOutlined, children: [] });
        }
        return availableMenus;
    }

    const getMenuAdministrative = () => {
        const availableMenus: IMenu[] = [];
        // dashboard - đầu tiên
        if (hasMenu(routerConstants.hanhchinh.trangChu)) {
            availableMenus.push({ key: 'administrativeDashboard', startPoint: routerConstants.hanhchinh.trangChu, path: routerConstants.hanhchinh.trangChu, label: 'Dashboard', icon: DashboardOutlined, children: [] });
        }
        // assetCategory - thứ 2
        if (hasMenu(routerConstants.hanhchinh.danhMucTaiSan.list)) {
            availableMenus.push({ key: 'assetCategory', startPoint: routerConstants.hanhchinh.danhMucTaiSan.name, path: routerConstants.hanhchinh.danhMucTaiSan.list, label: 'Danh mục tài sản', icon: AppstoreOutlined, children: [] });
        }
        // asset - thứ 3
        if (hasMenu(routerConstants.hanhchinh.taiSan.list)) {
            availableMenus.push({ key: 'administrativeAsset', startPoint: routerConstants.hanhchinh.taiSan.name, path: routerConstants.hanhchinh.taiSan.list, label: 'Tài sản', icon: BuildOutlined, children: [] });
        }
        // assetBorrowing - thứ 4
        if (hasMenu(routerConstants.hanhchinh.muonTraTaiSan.list)) {
            availableMenus.push({ key: 'assetBorrowing', startPoint: routerConstants.hanhchinh.muonTraTaiSan.name, path: routerConstants.hanhchinh.muonTraTaiSan.list, label: 'Mượn tài sản', icon: FileTextOutlined, children: [] });
        }
        // upcomingMaintenances - thứ 5
        if (hasMenu(routerConstants.hanhchinh.baoDuong.sapToi)) {
            availableMenus.push({ key: 'upcomingMaintenances', startPoint: routerConstants.hanhchinh.baoDuong.sapToi, path: routerConstants.hanhchinh.baoDuong.sapToi, label: 'Bảo trì sắp tới', icon: ToolOutlined, children: [] });
        }
        // meetingRoom - thứ 7
        if (hasMenu(routerConstants.hanhchinh.phongHop.list)) {
            availableMenus.push({ key: 'meetingRoom', startPoint: routerConstants.hanhchinh.phongHop.name, path: routerConstants.hanhchinh.phongHop.list, label: 'Phòng họp', icon: CalendarOutlined, children: [] });
        }
        // meetingBooking - thứ 8
        if (hasMenu(routerConstants.hanhchinh.datLichHop.list)) {
            availableMenus.push({ key: 'meetingBooking', startPoint: routerConstants.hanhchinh.datLichHop.name, path: routerConstants.hanhchinh.datLichHop.list, label: 'Đặt phòng họp', icon: CalendarOutlined, children: [] });
        }
        // meetingAttendee - thứ 9
        if (hasMenu(routerConstants.hanhchinh.thanhPhanThamDu.list)) {
            availableMenus.push({ key: 'meetingAttendee', startPoint: routerConstants.hanhchinh.thanhPhanThamDu.name, path: routerConstants.hanhchinh.thanhPhanThamDu.list, label: 'Người tham dự', icon: TeamOutlined, children: [] });
        }
        return availableMenus;
    }


    const getMenuPayroll = () => {
        const availableMenus: IMenu[] = [];
        if (hasMenu(routerConstants.bangLuong.thanhPhan.list)) {
            availableMenus.push({ key: 'payrollComponent', startPoint: routerConstants.bangLuong.thanhPhan.name, path: routerConstants.bangLuong.thanhPhan.list, label: 'Thành phần lương', icon: DollarOutlined, children: [] });
        }
        if (hasMenu(routerConstants.bangLuong.kyLuong.list)) {
            availableMenus.push({ key: 'payrollPeriod', startPoint: routerConstants.bangLuong.kyLuong.name, path: routerConstants.bangLuong.kyLuong.list, label: 'Kỳ lương', icon: DollarOutlined, children: [] });
        }
        if (hasMenu(routerConstants.bangLuong.bangLuong.list)) {
            availableMenus.push({ key: 'payslip', startPoint: routerConstants.bangLuong.bangLuong.name, path: routerConstants.bangLuong.bangLuong.list, label: 'Phiếu lương', icon: DollarOutlined, children: [] });
        }
        if (hasMenu(routerConstants.bangLuong.cauHinhLuong.list)) {
            availableMenus.push({ key: 'salaryConfig', startPoint: routerConstants.bangLuong.cauHinhLuong.name, path: routerConstants.bangLuong.cauHinhLuong.list, label: 'Cấu hình lương', icon: DollarOutlined, children: [] });
        }
        if (hasMenu('/bang-luong/cau-hinh-tinh-luong') || hasMenu(routerConstants.bangLuong.cauHinhLuong.list)) {
            availableMenus.push({ key: 'payrollCalcConfig', startPoint: 'cau-hinh-tinh-luong', path: '/bang-luong/cau-hinh-tinh-luong', label: 'Cấu hình BH / Thuế / Ngày lễ', icon: DollarOutlined, children: [] });
        }
        if (hasMenu(routerConstants.bangLuong.baoCao.tongHopQuy)) {
            availableMenus.push({ key: 'payrollFundSummary', startPoint: routerConstants.bangLuong.baoCao.tongHopQuy, path: routerConstants.bangLuong.baoCao.tongHopQuy, label: 'Báo cáo Tổng Quỹ Lương', icon: FileTextOutlined, children: [] });
        }
        if (hasMenu(routerConstants.bangLuong.baoCao.chiPhiNhanSu)) {
            availableMenus.push({ key: 'payrollHrCost', startPoint: routerConstants.bangLuong.baoCao.chiPhiNhanSu, path: routerConstants.bangLuong.baoCao.chiPhiNhanSu, label: 'Báo cáo Chi phí NS', icon: FileTextOutlined, children: [] });
        }
        if (hasMenu(routerConstants.bangLuong.baoCao.bienDongThuNhap)) {
            availableMenus.push({ key: 'payrollIncomeTrend', startPoint: routerConstants.bangLuong.baoCao.bienDongThuNhap, path: routerConstants.bangLuong.baoCao.bienDongThuNhap, label: 'Biến động thu nhập', icon: FileTextOutlined, children: [] });
        }
        if (hasMenu(routerConstants.bangLuong.dongBo.chamCong)) {
            availableMenus.push({ key: 'syncAttendance', startPoint: routerConstants.bangLuong.dongBo.chamCong, path: routerConstants.bangLuong.dongBo.chamCong, label: 'Đồng bộ Chấm công', icon: ClockCircleOutlined, children: [] });
        }
        return availableMenus;
    }

    const getMenuAttendance = () => {
        const availableMenus: IMenu[] = [];
        // history - xem lịch sử
        if (hasMenu(routerConstants.chamCong.lichSu)) {
            availableMenus.push({ key: 'attendanceHistory', startPoint: routerConstants.chamCong.lichSu, path: routerConstants.chamCong.lichSu, label: 'Lịch sử chấm công', icon: HistoryOutlined, children: [] });
        }
        // attendanceSummary - tổng hợp
        if (hasMenu(routerConstants.chamCong.tongHopCong.list)) {
            availableMenus.push({ key: 'attendanceSummary', startPoint: routerConstants.chamCong.tongHopCong.list, path: routerConstants.chamCong.tongHopCong.list, label: 'Tổng hợp công', icon: FileDoneOutlined, children: [] });
        }
        // workShift - cấu hình ca làm việc
        if (hasMenu(routerConstants.chamCong.caLamViec.list)) {
            availableMenus.push({ key: 'workShift', startPoint: routerConstants.chamCong.caLamViec.list, path: routerConstants.chamCong.caLamViec.list, label: 'Ca làm việc', icon: ClockCircleOutlined, children: [] });
        }
        // workSchedule - lịch phân ca
        if (hasMenu(routerConstants.chamCong.lichPhanCa.list)) {
            availableMenus.push({ key: 'workSchedule', startPoint: routerConstants.chamCong.lichPhanCa.list, path: routerConstants.chamCong.lichPhanCa.list, label: 'Lịch phân ca', icon: CalendarOutlined, children: [] });
        }
        // location - cấu hình vị trí
        if (hasMenu(routerConstants.chamCong.viTri.list)) {
            availableMenus.push({ key: 'attendanceLocation', startPoint: routerConstants.chamCong.viTri.list, path: routerConstants.chamCong.viTri.list, label: 'Vị trí chấm công', icon: BuildOutlined, children: [] });
        }
        // network - cấu hình mạng
        if (hasMenu(routerConstants.chamCong.mangNoiBo.list)) {
            availableMenus.push({ key: 'attendanceNetwork', startPoint: routerConstants.chamCong.mangNoiBo.list, path: routerConstants.chamCong.mangNoiBo.list, label: 'Mạng nội bộ', icon: BuildOutlined, children: [] });
        }
        return availableMenus;
    }

    const getMenuOffice = () => {
        const availableMenus: IMenu[] = [];
        // Đơn từ: 1 list bảng + lọc loại + tạo modal (không rải màn Xin nghỉ / Lịch sử)
        if (hasMenu(routerConstants.vanPhong.donTu.list)) {
            availableMenus.push({
                key: 'request',
                startPoint: routerConstants.vanPhong.donTu.name,
                path: routerConstants.vanPhong.donTu.list,
                label: 'Danh sách đơn từ',
                icon: FileTextOutlined,
                children: [],
            });
        }
        if (hasMenu(routerConstants.vanPhong.nghiPhep.choDuyet) || hasMenu('/van-phong/don-tu/cho-duyet')) {
            availableMenus.push({
                key: 'leavePending',
                startPoint: routerConstants.vanPhong.nghiPhep.choDuyet,
                path: routerConstants.vanPhong.nghiPhep.choDuyet,
                label: 'Chờ duyệt',
                icon: CheckCircleOutlined,
                children: [],
            });
        }
        if (hasMenu(routerConstants.vanPhong.nghiPhep.soDu)) {
            availableMenus.push({
                key: 'leaveBalance',
                startPoint: '/van-phong/nghi-phep/so-du',
                path: routerConstants.vanPhong.nghiPhep.soDu,
                label: 'Số dư phép',
                icon: CalendarOutlined,
                children: [],
            });
        }
        if (hasMenu(routerConstants.vanPhong.quyTrinhDuyet.list)) {
            availableMenus.push({
                key: 'workflow',
                startPoint: routerConstants.vanPhong.quyTrinhDuyet.name,
                path: routerConstants.vanPhong.quyTrinhDuyet.list,
                label: 'Cấu hình workflow',
                icon: FileDoneOutlined,
                children: [],
            });
        }
        return availableMenus;
    }

    // get menu 
    const menuSystem = getMenuSystem();
    const menuHR = getMenuHR();
    const menuDaoTao = getMenuDaoTao();
    const menuRecruitment = getMenuRecruitment();
    const menuAdministrative = getMenuAdministrative();
    const menuPayroll = getMenuPayroll();
    const menuAttendance = getMenuAttendance();
    const menuOffice = getMenuOffice();

    // Sắp xếp menu theo thứ tự ưu tiên sử dụng (từ thường dùng nhất đến ít dùng)

    // 1. Trang chủ — level 1, màn Home (/)
    menuApps.push({
        key: 'home',
        startPoint: '/',
        path: '/',
        label: 'Trang chủ',
        icon: HomeOutlined,
        children: [],
    });

    // 2. Bản tin — level 1 (mạng xã hội cũ)
    if (hasMenu(routerConstants.mangXaHoi.list)) {
        menuApps.push({
            key: 'socialFeed',
            startPoint: routerConstants.mangXaHoi.list,
            path: routerConstants.mangXaHoi.list,
            label: 'Bản tin',
            icon: ShareAltOutlined,
            children: [],
        });
    }

    // 3. Nhân sự
    if (menuHR.length > 0) {
        menuApps.push({
            key: 'hr',
            startPoint: "/nhan-su/",
            path: '',
            label: 'Nhân sự',
            icon: TeamOutlined,
            children: menuHR
        });
    }

    // 4. Chấm công
    if (menuAttendance.length > 0) {
        menuApps.push({
            key: 'attendance',
            startPoint: "/cham-cong/",
            path: '',
            label: 'Chấm công',
            icon: ClockCircleOutlined,
            children: menuAttendance
        });
    }

    // 5. Đơn từ - dùng thường xuyên
    if (menuOffice.length > 0) {
        menuApps.push({
            key: 'office',
            startPoint: "/van-phong/",
            path: '',
            label: 'Đơn từ',
            icon: FileDoneOutlined,
            children: menuOffice
        });
    }

    // 6. Đào tạo
    if (menuDaoTao.length > 0) {
        menuApps.push({
            key: 'training',
            startPoint: "/dao-tao/",
            path: '',
            label: 'Đào tạo',
            icon: ReadOutlined,
            children: menuDaoTao
        });
    }

    // 7. Lương
    if (menuPayroll.length > 0) {
        menuApps.push({
            key: 'payroll',
            startPoint: "/bang-luong/",
            path: '',
            label: 'Lương',
            icon: DollarOutlined,
            children: menuPayroll
        });
    }

    // 8. Tuyển dụng
    if (menuRecruitment.length > 0) {
        menuApps.push({
            key: 'recruitment',
            startPoint: "/tuyen-dung/",
            path: '',
            label: 'Tuyển dụng',
            icon: SolutionOutlined,
            children: menuRecruitment
        });
    }

    // 9. Hành chính (bao gồm Tài sản và Phòng họp)
    if (menuAdministrative.length > 0) {
        menuApps.push({
            key: 'administrative',
            startPoint: "/hanhchinh/",
            path: '',
            label: 'Hành chính',
            icon: BuildOutlined,
            children: menuAdministrative
        });
    }

    // 10. Hệ thống (bao gồm Quản trị) - cuối cùng
    if (menuSystem.length > 0) {
        menuApps.push({
            key: 'system',
            startPoint: "/admin/",
            path: '',
            label: 'Hệ thống',
            icon: AppstoreOutlined,
            children: menuSystem
        });
    }

    // 10. Module test — 1 menu / 1 link (trong trang chia nhiều khối)
    menuApps.push({
        key: 'moduleTest',
        startPoint: '/module-test',
        path: '/module-test',
        label: 'Module test',
        icon: ExperimentOutlined,
        children: [],
    });

    // 11. Test flow
    menuApps.push({
        key: 'testFlow',
        startPoint: '/test-flow',
        path: '/test-flow',
        label: 'Đánh giá hành trình',
        icon: NodeIndexOutlined,
        children: [],
    });

    // 12. Vận hành thử — thứ tự module + tiêu chí pass (menu level 1)
    menuApps.push({
        key: 'opsUat',
        startPoint: '/van-hanh-thu',
        path: '/van-hanh-thu',
        label: 'Vận hành thử',
        icon: RocketOutlined,
        children: [],
    });

    // 13. Base UI showcase
    menuApps.push({
        key: 'baseShowcase',
        startPoint: '/base-showcase',
        path: '/base-showcase',
        label: 'Base UI',
        icon: LayoutOutlined,
        children: [],
    });

    // 14. Tổng quan dự án
    menuApps.push({
        key: 'projectOverview',
        startPoint: '/tong-quan-du-an',
        path: '/tong-quan-du-an',
        label: 'Tổng quan dự án',
        icon: ApartmentOutlined,
        children: [],
    });

    return menuApps;
}
